// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"bQ-z","inlineTitle":"cQ-z","sponsoredAdsWrapper":"dQ-z","marketplaceRecosWrapper":"eQ-z"};